import React, { Fragment } from 'react';
import i18n from '../../utils/translate';
import { formatPrice } from 'utils/common';
import { PAYMENT_TYPE_BIANNUAL, PAYMENT_TYPE_MONTHLY, PAYMENT_TYPE_QUARTERLY } from './constants';

export const paymentDetails = (zahlungsweise, quote) => {
  let label = '';
  let price = '';

  switch (zahlungsweise) {
    case PAYMENT_TYPE_BIANNUAL:
      label = `${i18n('halbjährlich')}: `;
      price = formatPrice(quote.paymentVariants[PAYMENT_TYPE_BIANNUAL], quote.currency);
      break;
    case PAYMENT_TYPE_QUARTERLY:
      label = `${i18n('vierteljährlich')}: `;
      price = formatPrice(quote.paymentVariants[PAYMENT_TYPE_QUARTERLY], quote.currency);
      break;
    case PAYMENT_TYPE_MONTHLY:
      label = `${i18n('monatlich')}: `;
      price = formatPrice(quote.paymentVariants[PAYMENT_TYPE_MONTHLY], quote.currency);
      break;
    default:
      return;
  }
  return (
    <p>
      <small>
        {label} {<Fragment>{price}</Fragment>}
      </small>
    </p>
  );
};

export const calculateEndDate = startDate => {
  if (!startDate) return null;
  if (startDate.date() === 1) return startDate.clone().add(1, 'year').format('DD.MM.YYYY');
  return startDate.clone().add(1, 'months').startOf('month').add(1, 'year').format('DD.MM.YYYY');
};

export const numberToLocaleString = n => {
  var parts = n.toString().split('.');
  const numberPart = parts[0];
  const decimalPart = parts[1];
  const thousands = /\B(?=(\d{3})+(?!\d))/g;
  return numberPart.replace(thousands, '.') + (decimalPart ? '.' + decimalPart : ',00');
};
